import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
//import { saveTrader, getTraders } from '../../Api';
import useApi from '../../api/useApi';

const TraderDetail = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const api = useApi();

    const [formData, setFormData] = useState({
        traderId: 0,
        bidderName: '',
        address: '',
        telephoneNo: '',
        stateId: 0,
        mobileNo: '',
        districtId: 0,
        faxNumber: '',
        pincode: '',
        emailId: '',
        licenceNumber: '',
        vatGstNumber: '',
        licenceIssueDate: null,
        licenceExpiryDate: null,
        rcNumber: '',
        cstNumber: '',
        moneyDepositeType: '',
        amount: 0,
        chequeDdNumber: '',
        bankName: '',
        issueDate: null,
        expiryDate: null,
        remarks: '',
        userCode:'',
        useMobileNoAsPassword: true,
        password: '',
        isPasswordChanged: false
    });


    const fetchDataFromApi = async () => {
        try {
            const traderDetail = await api.getTraders(id);
            const trader = traderDetail[0]; // Assuming there's only one trader returned
            const formattedData = {
                traderId: trader.traderId,
                bidderName: trader.bidderName,
                address: trader.address,
                telephoneNo: trader.telephoneNo,
                mobileNo: trader.mobileNo,
                faxNumber: trader.faxNumber,
                pincode: trader.pincode,
                emailId: trader.emailId,
                stateId: trader.stateId,
                districtId: trader.districtId,
                licenceNumber: trader.licenceNumber,
                vatGstNumber: trader.vatgstNumber,
                licenceIssueDate: trader.licenceIssueDate ? new Date(trader.licenceIssueDate) : null,
                licenceExpiryDate: trader.licenceExpiryDate ? new Date(trader.licenceExpiryDate) : null,
                rcNumber: trader.rcNumber,
                cstNumber: trader.cstNumber,
                moneyDepositeType: trader.moneyDepositeType,
                amount: trader.amount,
                chequeDdNumber: trader.chequeDDNumber,
                bankName: trader.bankName,
                issueDate: trader.issueDate ? new Date(trader.issueDate) : null,
                expiryDate: trader.expiryDate ? new Date(trader.expiryDate) : null,
                remarks: trader.remarks,
                status: trader.status,
                userCode: trader.userCode,
                useMobileNoAsPassword: trader.useMobileNoAsPassword,
                password: trader.useMobileNoAsPassword ? trader.mobileNo:'1234',
                isPasswordChanged: false
            };
            setFormData(formattedData);

        } catch (error) {
            alert('Unable to fetch trader detail data.');
        }
    };

    useEffect(() => {
        if (id > 0)
            fetchDataFromApi();
    }, []);


    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
            isPasswordChanged: e.target.name === 'password' ? true : false
        });
    };

    const handleDateChange = (date, field) => {
        setFormData({
            ...formData,
            [field]: date,
        });
    };

    const handleCheckboxChange = (e) => {
        setFormData({
            ...formData,
            useMobileNoAsPassword: e.target.checked,
            password: e.target.checked ? formData.mobileNo:''
        });
    };

    const handleRadioChange = (e) => {
        setFormData({
            ...formData,
            moneyDepositeType: e.target.value,
        });
    };

    const goBack = () => {
        navigate(`/traders`);
    }


    const handleSave = async () => {
        await api.saveTrader(formData)
            .then((response) => {

                if (response.success) {
                    alert(response.message);
                    navigate(`/traders`);
                }
                else
                    alert(response.message);
              
            })
            .catch((error) => {
                // Handle error
                console.error('Error saving trader:', error);
            });
    };



    return (
        <div className="inner-body">
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Traders</h2>
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                            <a className="custom-link" onClick={()=>navigate('/home') }>Home</a></li>
                        <li className="breadcrumb-item">
                            <a className="custom-link" onClick={()=>navigate('/traders') }>Traders</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Trader Detail</li>
                    </ol>
                </div>
                <div className="d-flex">

                </div>
            </div>
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12">
                    <div className="card custom-card">
                        <div className="card-body pd-l-40">
                            <div>
                                <h6 className="main-content-label mg-b-1">Add/Edit Trader Detail</h6>
                            </div>

                            <div>
                                <h6 className="main-content-label text-primary mg-t-10 bg-gray-200 pd-8">
                                    Trader Detail
                                </h6>
                            </div>
                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="mg-t-8">Name of Bidder</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="bidderName" className="form-control med-height" onChange={handleInputChange} value={formData.bidderName} />
                                </div>

                            </div>

                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="mg-t-8">Address</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <textarea name="address" className="form-control med-height" rows="3" onChange={handleInputChange} value={formData.address} />
                                </div>
                                <div className="offset-md-1 col-md-2">
                                    <label className="mg-t-8">Telephone Number</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="telephoneNo" className="form-control med-height" onChange={handleInputChange} value={formData.telephoneNo} />
                                </div>
                            </div>
                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="mg-t-8">State</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <select name="stateId" className="form-control med-height" onChange={handleInputChange} value={formData.stateId} >
                                        <option value="1">Andhra Pradesh</option>
                                        <option value="2">Andman & Nicobar Island</option>
                                        <option value="3">Arunachal Pradesh</option>
                                        <option value="4">Assam</option>
                                        <option value="5">Bihar</option>
                                        <option value="6">Chandigarh</option>
                                        <option value="7">Chattisgarh</option>
                                        <option value="8">Dadar & Nagar Havali</option>
                                        <option value="9">Daman & Diu</option>
                                        <option value="10">Delhi</option>
                                        <option value="11">Goa</option>
                                        <option value="12">Gujarat</option>
                                        <option value="13">Haryana</option>
                                        <option value="14">Himachal Pradesh</option>
                                        <option value="15">Jammu & Kashmir</option>
                                        <option value="16">Jharkhand</option>
                                        <option value="17">Karnataka</option>
                                        <option value="18">Kerala</option>
                                        <option value="19">Lakshadweep</option>
                                        <option value="20">Madhya Pradesh</option>
                                        <option value="21">Maharashtra</option>
                                        <option value="22">Manipur</option>
                                        <option value="23">Meghalaya</option>
                                        <option value="24">Mizoram</option>
                                        <option value="25">Nagaland</option>
                                        <option value="26">Orissa</option>
                                        <option value="27">Pondicherry</option>
                                        <option value="28">Punjab</option>
                                        <option value="29">Rajasthan</option>
                                        <option value="30">Sikkim</option>
                                        <option value="31">Tamilnadu</option>
                                        <option value="32">Tripura</option>
                                        <option value="33">Uttar Pradesh</option>
                                        <option value="34">Uttrakhand</option>
                                        <option value="35">West Bengal</option>
                                    </select>
                                </div>
                                <div className="offset-md-1 col-md-2">
                                    <label className="mg-t-8">Mobile Number</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="mobileNo" className="form-control med-height"  onChange={handleInputChange} value={formData.mobileNo} />
                                </div>
                            </div>
                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="mg-t-8">District</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <select name="districtId" className="form-control med-height" onChange={handleInputChange} value={formData.districtId}>
                                        <option value="1">Adilabad</option>
                                        <option value="2">Agra</option>
                                        <option value="3">Ahmedabad</option>
                                        <option value="4">Ahmednagar</option>
                                        <option value="5">Aizawal West</option>
                                        <option value="6">Aizawl East</option>
                                        <option value="7">Ajmer</option>
                                        <option value="8">Akola</option>
                                        <option value="9">Alappuzha</option>
                                        <option value="10">Aligarh</option>
                                        <option value="11">Allahabad</option>
                                        <option value="12">Almora</option>
                                        <option value="13">Alwar</option>
                                        <option value="14">Amaravati</option>
                                        <option value="15">Ambala</option>
                                        <option value="16">Ambedkar Nagar</option>
                                        <option value="17">Amreli</option>
                                        <option value="18">Amritsar</option>
                                        <option value="19">Anand</option>
                                        <option value="20">Anantapur</option>
                                        <option value="21">Andaman Nicobar Is</option>
                                        <option value="22">Angul</option>
                                        <option value="23">Anjaw</option>
                                        <option value="24">Anupur</option>
                                        <option value="25">Aranthangi</option>
                                        <option value="26">Araria</option>
                                        <option value="27">Arwal</option>
                                        <option value="28">Ashok Nagar</option>
                                        <option value="29">Auraiya</option>
                                        <option value="30">Aurangabad</option>
                                        <option value="31">Aurangabad-Bi</option>
                                        <option value="32">Azamgarh</option>
                                        <option value="33">Bagalkot</option>
                                        <option value="34">Bageshwar</option>
                                        <option value="35">Baghpat</option>
                                        <option value="36">Bahraich</option>
                                        <option value="37">Baksa</option>
                                        <option value="38">Balaghat</option>
                                        <option value="39">Balangir</option>
                                        <option value="40">Baleshwar</option>
                                        <option value="41">Ballia</option>
                                        <option value="42">Balrampur</option>
                                        <option value="43">Banaskantha</option>
                                        <option value="44">Banda</option>
                                        <option value="45">Bangalore Rural</option>
                                        <option value="46">Bangalore Urban</option>
                                        <option value="47">Banka</option>
                                        <option value="48">Bankura</option>
                                        <option value="49">Banswara</option>
                                        <option value="50">Barabanki</option>
                                        <option value="51">Baramula</option>
                                        <option value="52">Baran</option>
                                        <option value="53">Barddhaman</option>
                                        <option value="54">Bareilly</option>
                                        <option value="55">Bargarh</option>
                                        <option value="56">Barmer</option>
                                        <option value="57">Barnala</option>
                                        <option value="58">Barpeta</option>
                                        <option value="59">Barwani</option>
                                        <option value="60">Bastar</option>
                                        <option value="61">Basti</option>
                                        <option value="62">Bathinda</option>
                                        <option value="63">Baudh</option>
                                        <option value="64">Beed</option>
                                        <option value="65">Begusarai</option>
                                        <option value="66">Belgaum</option>
                                        <option value="67">Bellary</option>
                                        <option value="68">Betul</option>
                                        <option value="69">Bhadrak</option>
                                        <option value="70">Bhagalpur</option>
                                        <option value="71">Bhandara</option>
                                        <option value="72">Bharatpur</option>
                                        <option value="73">Bharuch</option>
                                        <option value="74">Bhavnagar</option>
                                        <option value="75">Bhilwara</option>
                                        <option value="76">Bhind</option>
                                        <option value="77">Bhiwani</option>
                                        <option value="78">Bhoi</option>
                                        <option value="79">Bhojpur</option>
                                        <option value="80">Bhopal</option>
                                        <option value="81">Bidar</option>
                                        <option value="82">Bijapur</option>
                                        <option value="83">Bijnor</option>
                                        <option value="84">Bikaner</option>
                                        <option value="85">Bilaspur-Cg</option>
                                        <option value="86">Bilaspur-Hp</option>
                                        <option value="87">Birbhum</option>
                                        <option value="88">Bishnupur</option>
                                        <option value="89">Bokaro</option>
                                        <option value="90">Bongaigaon</option>
                                        <option value="91">Budaun</option>
                                        <option value="92">Bulandshahar</option>
                                        <option value="93">Buldana</option>
                                        <option value="94">Bundi</option>
                                        <option value="95">Burhanpur</option>
                                        <option value="96">Buxar</option>
                                        <option value="97">Cachar</option>
                                        <option value="98">Central</option>
                                        <option value="99">Chamarajanagar</option>
                                        <option value="100">Chamba</option>
                                        <option value="101">Chamoli</option>
                                        <option value="102">Champawat</option>
                                        <option value="103">Champhai</option>
                                        <option value="104">Chandauli</option>
                                        <option value="105">Chandel</option>
                                        <option value="106">Chandigarh</option>
                                        <option value="107">Chandrapur</option>
                                        <option value="108">Changlang</option>
                                        <option value="109">Chatra</option>
                                        <option value="110">Chennai Corp</option>
                                        <option value="111">Cheyyar</option>
                                        <option value="112">Chhatarpur</option>
                                        <option value="113">Chhindwara</option>
                                        <option value="114">Chikkaballapur</option>
                                        <option value="115">Chikmagalur</option>
                                        <option value="116">Chirang</option>
                                        <option value="117">Chitradurga</option>
                                        <option value="118">Chitrakoot</option>
                                        <option value="119">Chittaurgarh</option>
                                        <option value="120">Chittoor</option>
                                        <option value="121">Churachandpur</option>
                                        <option value="122">Churu</option>
                                        <option value="123">City Zone</option>
                                        <option value="124">Civili Line</option>
                                        <option value="125">Coimbatore</option>
                                        <option value="126">Cooch Behar</option>
                                        <option value="127">Cuddalore</option>
                                        <option value="128">Cuttack</option>
                                        <option value="129">Dadra & Nagar Haveli</option>
                                        <option value="130">Dahod</option>
                                        <option value="131">Dakshin Dinajpur</option>
                                        <option value="132">Dakshina Kannada</option>
                                        <option value="133">Daman</option>
                                        <option value="134">Damoh</option>
                                        <option value="135">Dang</option>
                                        <option value="136">Dantewada</option>
                                        <option value="137">Darbhanga</option>
                                        <option value="138">Darjiling</option>
                                        <option value="139">Darrang</option>
                                        <option value="140">Datia</option>
                                        <option value="141">Dausa</option>
                                        <option value="142">Davanagere</option>
                                        <option value="143">Debagarh</option>
                                        <option value="144">Dehradun</option>
                                        <option value="145">Deogarh</option>
                                        <option value="146">Deoria</option>
                                        <option value="147">Dewas</option>
                                        <option value="148">Dhamtari</option>
                                        <option value="149">Dhanbad</option>
                                        <option value="150">Dhar</option>
                                        <option value="151">Dharapuram</option>
                                        <option value="152">Dharmapuri</option>
                                        <option value="153">Dharwad</option>
                                        <option value="154">Dhaulpur</option>
                                        <option value="155">Dhemaji</option>
                                        <option value="156">Dhenkanal</option>
                                        <option value="157">Dhubri</option>
                                        <option value="158">Dhule</option>
                                        <option value="159">Dibrugarh</option>
                                        <option value="160">Dimapur</option>
                                        <option value="161">Dindigul</option>
                                        <option value="162">Dindori</option>
                                        <option value="163">Diu</option>
                                        <option value="164">Doda</option>
                                        <option value="165">Dumka</option>
                                        <option value="166">Dungarpur</option>
                                        <option value="167">Durg</option>
                                        <option value="168">East</option>
                                        <option value="169">East /Dhalai Tripura</option>
                                        <option value="170">East Champaran</option>
                                        <option value="171">East Garo Hills</option>
                                        <option value="172">East Godavari</option>
                                        <option value="173">East Kameng</option>
                                        <option value="174">East Khasi Hills</option>
                                        <option value="175">East Medinipur</option>
                                        <option value="176">East Siang</option>
                                        <option value="177">East Singhbhum</option>
                                        <option value="178">Ernakulam</option>
                                        <option value="179">Erode</option>
                                        <option value="180">Etah</option>
                                        <option value="181">Etawah</option>
                                        <option value="182">Faizabad</option>
                                        <option value="183">Faridabad</option>
                                        <option value="184">Faridkot</option>
                                        <option value="185">Farrukhabad</option>
                                        <option value="186">Fategarh Sahib</option>
                                        <option value="187">Fatehabad</option>
                                        <option value="188">Fatehpur</option>
                                        <option value="189">Firozabad</option>
                                        <option value="190">Firozpur</option>
                                        <option value="191">Gadag</option>
                                        <option value="192">Gadchiroli</option>
                                        <option value="193">Gajapati</option>
                                        <option value="194">Gandhinagar</option>
                                        <option value="195">Ganganagar</option>
                                        <option value="196">Ganjam</option>
                                        <option value="197">Garhwa</option>
                                        <option value="198">Gautam Budh Nagar</option>
                                        <option value="199">Gaya</option>
                                        <option value="200">Ghaziabad</option>
                                        <option value="201">Ghazipur</option>
                                        <option value="202">Giridih</option>
                                        <option value="203">Goa</option>
                                        <option value="204">Goalpara</option>
                                        <option value="205">Godda</option>
                                        <option value="206">Godhara</option>
                                        <option value="207">Golaghat</option>
                                        <option value="208">Gonda</option>
                                        <option value="209">Gondia</option>
                                        <option value="210">Gopalganj</option>
                                        <option value="211">Gorakhpur</option>
                                        <option value="212">Gulbarga</option>
                                        <option value="213">Gumla</option>
                                        <option value="214">Guna</option>
                                        <option value="215">Guntur</option>
                                        <option value="216">Gurdaspur</option>
                                        <option value="217">Gurgaon</option>
                                        <option value="218">Gwalior</option>
                                        <option value="219">Hailakandi</option>
                                        <option value="220">Hamirpur-Hp</option>
                                        <option value="221">Hamirpur-Up</option>
                                        <option value="222">Hanumangarh</option>
                                        <option value="223">Haora / Howrah</option>
                                        <option value="224">Harda</option>
                                        <option value="225">Hardoi</option>
                                        <option value="226">Hardwar</option>
                                        <option value="227">Hassan</option>
                                        <option value="228">Hathras/Mahamayanagar</option>
                                        <option value="229">Haveri</option>
                                        <option value="230">Hazaribagh</option>
                                        <option value="231">Hingoli</option>
                                        <option value="232">Hisar</option>
                                        <option value="233">Hoshangabad</option>
                                        <option value="234">Hoshiarpur</option>
                                        <option value="235">Hugly</option>
                                        <option value="236">Hyderabad</option>
                                        <option value="237">Idukki</option>
                                        <option value="238">Imphal East</option>
                                        <option value="239">Imphal West</option>
                                        <option value="240">Indore</option>
                                        <option value="241">Jabalpur</option>
                                        <option value="242">Jagatsinghapur</option>
                                        <option value="243">Jaintia Hills</option>
                                        <option value="244">Jaipur</option>
                                        <option value="245">Jaisalmer</option>
                                        <option value="246">Jajpur</option>
                                        <option value="247">Jalandhar</option>
                                        <option value="248">Jalaun</option>
                                        <option value="249">Jalgaon</option>
                                        <option value="250">Jalna</option>
                                        <option value="251">Jalore</option>
                                        <option value="252">Jalpaiguri</option>
                                        <option value="253">Jammu</option>
                                        <option value="254">Jamnagar</option>
                                        <option value="255">Jamtara</option>
                                        <option value="256">Jamui</option>
                                        <option value="257">Janjgir</option>
                                        <option value="258">Jashpur</option>
                                        <option value="259">Jaunpur</option>
                                        <option value="260">Jehanabad</option>
                                        <option value="261">Jhabua</option>
                                        <option value="262">Jhajjar</option>
                                        <option value="263">Jhalawar</option>
                                        <option value="264">Jhansi</option>
                                        <option value="265">Jharsuguda</option>
                                        <option value="266">Jhunjhunun</option>
                                        <option value="267">Jind</option>
                                        <option value="268">Jodhpur</option>
                                        <option value="269">Jorhat</option>
                                        <option value="270">Junagadh</option>
                                        <option value="271">Jyotiba Phule Nagar</option>
                                        <option value="272">Kadapa</option>
                                        <option value="273">Kaimur</option>
                                        <option value="274">Kaithal</option>
                                        <option value="275">Kalahandi</option>
                                        <option value="276">Kallakurichi</option>
                                        <option value="277">Kamrup</option>
                                        <option value="278">Kancheepuram</option>
                                        <option value="279">Kandhamal</option>
                                        <option value="280">Kangpokpi</option>
                                        <option value="281">Kangra</option>
                                        <option value="282">Kanker</option>
                                        <option value="283">Kannauj</option>
                                        <option value="284">Kannur</option>
                                        <option value="285">Kanpur Dehat</option>
                                        <option value="286">Kanpur Nagar</option>
                                        <option value="287">Kapurthala</option>
                                        <option value="288">Karauli</option>
                                        <option value="289">Karbi Anglong</option>
                                        <option value="290">Karimganj</option>
                                        <option value="291">Karimnagar</option>
                                        <option value="292">Karnal</option>
                                        <option value="293">Karol Bagh</option>
                                        <option value="294">Karur</option>
                                        <option value="295">Kasaragod</option>
                                        <option value="296">Kathua</option>
                                        <option value="297">Katihar</option>
                                        <option value="298">Katni</option>
                                        <option value="299">Kaushambi</option>
                                        <option value="300">Kawardha/Kabir Dham</option>
                                        <option value="301">Kendrapara</option>
                                        <option value="302">Keonjhar</option>
                                        <option value="303">Khagaria</option>
                                        <option value="304">Khammam/Bhadrachalam</option>
                                        <option value="305">Khandwa</option>
                                        <option value="306">Khargone</option>
                                        <option value="307">Kheda</option>
                                        <option value="308">Kheri</option>
                                        <option value="309">Khurda</option>
                                        <option value="310">Kiphire</option>
                                        <option value="311">Kishanganj</option>
                                        <option value="312">Kishtwar</option>
                                        <option value="313">Kodagu</option>
                                        <option value="314">Kodarma</option>
                                        <option value="315">Kohima</option>
                                        <option value="316">Kokrajhar</option>
                                        <option value="317">Kolar</option>
                                        <option value="318">Kolasib</option>
                                        <option value="319">Kolhapur</option>
                                        <option value="320">Kolkata</option>
                                        <option value="321">Kollam</option>
                                        <option value="322">Koppal</option>
                                        <option value="323">Koraput</option>
                                        <option value="324">Korba</option>
                                        <option value="325">Koriya</option>
                                        <option value="326">Kota</option>
                                        <option value="327">Kottayam</option>
                                        <option value="328">Kovilpatti</option>
                                        <option value="329">Kozhikode</option>
                                        <option value="330">Krishna</option>
                                        <option value="331">Krishnagiri</option>
                                        <option value="332">Kullu</option>
                                        <option value="333">Kurnool</option>
                                        <option value="334">Kurukshetra</option>
                                        <option value="335">Kurung Kumey</option>
                                        <option value="336">Kushinagar</option>
                                        <option value="337">Kutch</option>
                                        <option value="338">Lakhimpur</option>
                                        <option value="339">Lakhisarai</option>
                                        <option value="340">Lakshadweep</option>
                                        <option value="341">Lalitpur</option>
                                        <option value="342">Lathehar</option>
                                        <option value="343">Latur</option>
                                        <option value="344">Lawngtlai</option>
                                        <option value="345">Lohardaga</option>
                                        <option value="346">Lohit</option>
                                        <option value="347">Longleng</option>
                                        <option value="348">Lower Dibang Valley</option>
                                        <option value="349">Lower Subansiri</option>
                                        <option value="350">Lucknow</option>
                                        <option value="351">Ludhiana</option>
                                        <option value="352">Lunglei</option>
                                        <option value="353">Madhepura</option>
                                        <option value="354">Madhubani</option>
                                        <option value="355">Madurai</option>
                                        <option value="356">Maharajganj</option>
                                        <option value="357">Mahasamund</option>
                                        <option value="358">Mahbubnagar</option>
                                        <option value="359">Mahesana</option>
                                        <option value="360">Mahoba</option>
                                        <option value="361">Mainpuri</option>
                                        <option value="362">Malappuram</option>
                                        <option value="363">Maldah</option>
                                        <option value="364">Malkangiri</option>
                                        <option value="365">Mamit</option>
                                        <option value="366">Mandi</option>
                                        <option value="367">Mandla</option>
                                        <option value="368">Mandsaur</option>
                                        <option value="369">Mandya</option>
                                        <option value="370">Mansa-Pu</option>
                                        <option value="371">Marigaon</option>
                                        <option value="372">Mathura</option>
                                        <option value="373">Mau</option>
                                        <option value="374">Mayurbhanj</option>
                                        <option value="375">Medak</option>
                                        <option value="376">Meerut</option>
                                        <option value="377">Mewat</option>
                                        <option value="378">Mirzapur</option>
                                        <option value="379">Moga</option>
                                        <option value="380">Mohali/Sasnagar</option>
                                        <option value="381">Mokokchung</option>
                                        <option value="382">Mon</option>
                                        <option value="383">Moradabad</option>
                                        <option value="384">Morena</option>
                                        <option value="385">Mukatsar</option>
                                        <option value="386">Munger</option>
                                        <option value="387">Murshidabad</option>
                                        <option value="388">Muzaffarnagar</option>
                                        <option value="389">Muzaffarpur</option>
                                        <option value="390">Mysore</option>
                                        <option value="391">Nabarangapur</option>
                                        <option value="392">Nadia</option>
                                        <option value="393">Nagaon</option>
                                        <option value="394">Nagapattinam</option>
                                        <option value="395">Nagaur</option>
                                        <option value="396">Nagercoil</option>
                                        <option value="397">Nagpur</option>
                                        <option value="398">Nainital</option>
                                        <option value="399">Najafgarh</option>
                                        <option value="400">Nalanda</option>
                                        <option value="401">Nalbari</option>
                                        <option value="402">Nalgonda</option>
                                        <option value="403">Namakkal</option>
                                        <option value="404">Nanded</option>
                                        <option value="405">Nandurbar</option>
                                        <option value="406">Narela</option>
                                        <option value="407">Narmada</option>
                                        <option value="408">Narnaul</option>
                                        <option value="409">Narsinghpur</option>
                                        <option value="410">Nasik</option>
                                        <option value="411">Navsari</option>
                                        <option value="412">Nawada</option>
                                        <option value="413">Nawanshahr</option>
                                        <option value="414">Nayagarh</option>
                                        <option value="415">Neemuch</option>
                                        <option value="416">Nellore</option>
                                        <option value="417">Nizamabad</option>
                                        <option value="418">North</option>
                                        <option value="419">North 24 Parganas</option>
                                        <option value="420">North Cachar Hills</option>
                                        <option value="421">North Tripura</option>
                                        <option value="422">Nuapada</option>
                                        <option value="423">Osmanabad</option>
                                        <option value="424">Pakur</option>
                                        <option value="425">Palakkad</option>
                                        <option value="426">Palamu</option>
                                        <option value="427">Palani</option>
                                        <option value="428">Pali</option>
                                        <option value="429">Palwal</option>
                                        <option value="430">Panchkula</option>
                                        <option value="431">Panipat</option>
                                        <option value="432">Panna</option>
                                        <option value="433">Papum Pare</option>
                                        <option value="434">Paramakudi</option>
                                        <option value="435">Parbhani</option>
                                        <option value="436">Patan</option>
                                        <option value="437">Pathanamthitta</option>
                                        <option value="438">Patiala</option>
                                        <option value="439">Patna</option>
                                        <option value="440">Pauri Garhwal</option>
                                        <option value="441">Perambalur</option>
                                        <option value="442">Peren</option>
                                        <option value="443">Phek</option>
                                        <option value="444">Pilibhit</option>
                                        <option value="445">Pithoragarh</option>
                                        <option value="446">Pondicherry</option>
                                        <option value="447">Poonamallee</option>
                                        <option value="448">Poonch</option>
                                        <option value="449">Porbandar</option>
                                        <option value="450">Prakasam</option>
                                        <option value="451">Pratapgarh</option>
                                        <option value="452">Pratapgarh</option>
                                        <option value="453">Pudukottai</option>
                                        <option value="454">Pune</option>
                                        <option value="455">Puri</option>
                                        <option value="456">Purnia</option>
                                        <option value="457">Puruliya</option>
                                        <option value="458">Raebareli</option>
                                        <option value="459">Raichur</option>
                                        <option value="460">Raigad</option>
                                        <option value="461">Raigarh-Cg</option>
                                        <option value="462">Raipur</option>
                                        <option value="463">Raisen</option>
                                        <option value="464">Rajgarh</option>
                                        <option value="465">Rajkot</option>
                                        <option value="466">Rajnandgaon</option>
                                        <option value="467">Rajouri</option>
                                        <option value="468">Rajsamand</option>
                                        <option value="469">Ramanagara</option>
                                        <option value="470">Ramanathapuram</option>
                                        <option value="471">Ramban</option>
                                        <option value="472">Rampur</option>
                                        <option value="473">Ranchi</option>
                                        <option value="474">Rangareddi</option>
                                        <option value="475">Ratlam</option>
                                        <option value="476">Ratnagiri</option>
                                        <option value="477">Rayagada</option>
                                        <option value="478">Reasi</option>
                                        <option value="479">Rewa</option>
                                        <option value="480">Rewari</option>
                                        <option value="481">Rohini</option>
                                        <option value="482">Rohtak</option>
                                        <option value="483">Rohtas</option>
                                        <option value="484">Rudraprayag</option>
                                        <option value="485">Rupnagar/Ropar</option>
                                        <option value="486">S. Pahar Ganj</option>
                                        <option value="487">Sabarkantha</option>
                                        <option value="488">Sagar</option>
                                        <option value="489">Saharanpur</option>
                                        <option value="490">Saharsa</option>
                                        <option value="491">Sahibganj</option>
                                        <option value="492">Saidapet</option>
                                        <option value="493">Saiha</option>
                                        <option value="494">Salem</option>
                                        <option value="495">Samastipur</option>
                                        <option value="496">Sambalpur</option>
                                        <option value="497">Sambha</option>
                                        <option value="498">Sangli</option>
                                        <option value="499">Sangrur</option>
                                        <option value="500">Sankarankoil</option>
                                        <option value="501">Sant Kabir Nagar</option>
                                        <option value="502">Sant Ravidas Nagar</option>
                                        <option value="503">Saraikela-Kharsawan</option>
                                        <option value="504">Saran</option>
                                        <option value="505">Satara</option>
                                        <option value="506">Satna</option>
                                        <option value="507">Sawai Madhopur</option>
                                        <option value="508">Senapati</option>
                                        <option value="509">Seoni</option>
                                        <option value="510">Serchhip</option>
                                        <option value="511">Shahadra (N)</option>
                                        <option value="512">Shahadra (S)</option>
                                        <option value="513">Shahdol</option>
                                        <option value="514">Shahjahanpur</option>
                                        <option value="515">Shajapur</option>
                                        <option value="516">Sheikhpura</option>
                                        <option value="517">Sheohar</option>
                                        <option value="518">Sheopur</option>
                                        <option value="519">Shimla</option>
                                        <option value="520">Shimoga</option>
                                        <option value="521">Shivpuri</option>
                                        <option value="522">Shravasti</option>
                                        <option value="523">Sibsagar</option>
                                        <option value="524">Siddharthnagar</option>
                                        <option value="525">Sidhi</option>
                                        <option value="526">Sikar</option>
                                        <option value="527">Simdega</option>
                                        <option value="528">Sindhudurg</option>
                                        <option value="529">Sirmaur</option>
                                        <option value="530">Sirohi</option>
                                        <option value="531">Sirsa</option>
                                        <option value="532">Sitamarhi</option>
                                        <option value="533">Sitapur</option>
                                        <option value="534">Sivaganga</option>
                                        <option value="535">Sivakasi</option>
                                        <option value="536">Siwan</option>
                                        <option value="537">Solan</option>
                                        <option value="538">Solapur</option>
                                        <option value="539">Sonapur / Subarnapur</option>
                                        <option value="540">Sonbhadra</option>
                                        <option value="541">Sonipat</option>
                                        <option value="542">Sonitpur</option>
                                        <option value="543">South</option>
                                        <option value="544">South</option>
                                        <option value="545">South 24 Parganas</option>
                                        <option value="546">South Garo Hills</option>
                                        <option value="547">South Tripura</option>
                                        <option value="548">Srikakulam</option>
                                        <option value="549">Sultanpur</option>
                                        <option value="550">Sundargarh</option>
                                        <option value="551">Supaul</option>
                                        <option value="552">Surat</option>
                                        <option value="553">Surendranagar</option>
                                        <option value="554">Surguja (Ambikapur)</option>
                                        <option value="555">Tamenglong</option>
                                        <option value="556">Tapi</option>
                                        <option value="557">Tarn Taran</option>
                                        <option value="558">Tawang</option>
                                        <option value="559">Tehri Garhwal</option>
                                        <option value="560">Thane</option>
                                        <option value="561">Thanjavur</option>
                                        <option value="562">The Nilgiris</option>
                                        <option value="563">Theni</option>
                                        <option value="564">Thiruchirapalli</option>
                                        <option value="565">Thirunelveli</option>
                                        <option value="566">Thiruppattur</option>
                                        <option value="567">Thiruppur</option>
                                        <option value="568">Thiruvallore</option>
                                        <option value="569">Thiruvananthapuram</option>
                                        <option value="570">Thiruvarur</option>
                                        <option value="571">Thoothukudi</option>
                                        <option value="572">Thoubal</option>
                                        <option value="573">Thrissur</option>
                                        <option value="574">Tikamgarh</option>
                                        <option value="575">Tinsukia</option>
                                        <option value="576">Tirap</option>
                                        <option value="577">Tiruvannamalai</option>
                                        <option value="578">Tonk</option>
                                        <option value="579">Tuensang</option>
                                        <option value="580">Tumkur</option>
                                        <option value="581">Udaipur</option>
                                        <option value="582">Udalguri</option>
                                        <option value="583">Udham Singh Nagar</option>
                                        <option value="584">Udhampur</option>
                                        <option value="585">Udupi</option>
                                        <option value="586">Ujjain</option>
                                        <option value="587">Ukhrul</option>
                                        <option value="588">Umaria</option>
                                        <option value="589">Una</option>
                                        <option value="590">Unnao</option>
                                        <option value="591">Upper Dibang Valley</option>
                                        <option value="592">Upper Siang</option>
                                        <option value="593">Upper Subansiri</option>
                                        <option value="594">Uttar Dinajpur</option>
                                        <option value="595">Uttara Kannada</option>
                                        <option value="596">Uttarkashi</option>
                                        <option value="597">Vadodara</option>
                                        <option value="598">Vaishali</option>
                                        <option value="599">Valsad</option>
                                        <option value="600">Varanasi</option>
                                        <option value="601">Vellore</option>
                                        <option value="602">Vidisha</option>
                                        <option value="603">Villupuram</option>
                                        <option value="604">Virudhunagar</option>
                                        <option value="605">Visakhapatnam</option>
                                        <option value="606">Vizianagaram</option>
                                        <option value="607">Warangal</option>
                                        <option value="608">Wardha</option>
                                        <option value="609">Washim</option>
                                        <option value="610">Wayanad</option>
                                        <option value="611">West</option>
                                        <option value="612">West</option>
                                        <option value="613">West Champaran</option>
                                        <option value="614">West Garo Hills</option>
                                        <option value="615">West Godavari</option>
                                        <option value="616">West Kameng</option>
                                        <option value="617">West Khasi Hills</option>
                                        <option value="618">West Mednapur</option>
                                        <option value="619">West Siang</option>
                                        <option value="620">West Singhbhum</option>
                                        <option value="621">West Tripura</option>
                                        <option value="622">Wokha</option>
                                        <option value="623">Yamunanagar</option>
                                        <option value="624">Yawatmal</option>
                                        <option value="625">Zunheboto</option>
                                    </select>
                                </div>
                                <div className="offset-md-1 col-md-2">
                                    <label className="mg-t-8">Fax Number</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="faxNumber" className="form-control med-height" onChange={handleInputChange} value={formData.faxNumber} />
                                </div>
                            </div>
                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="mg-t-8">Pincode</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="pincode" className="form-control med-height" onChange={handleInputChange} value={formData.pincode} />
                                </div>
                                <div className="offset-md-1 col-md-2">
                                    <label className="mg-t-8">Email Id</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="emailId" className="form-control med-height" onChange={handleInputChange} value={formData.emailId} />
                                </div>
                            </div>

                            <div>
                                <h6 className="main-content-label text-primary mg-t-35 bg-gray-200 pd-8">
                                    Spices Board Detail
                                </h6>
                            </div>
                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="">Spices Board Licence Number</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="licenceNumber" className="form-control med-height" onChange={handleInputChange} value={formData.licenceNumber} />
                                </div>
                                <div className="offset-md-1 col-md-2">
                                    <label className="mg-t-8">VAT/GST Number</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="vatGstNumber" className="form-control med-height" onChange={handleInputChange} value={formData.vatGstNumber} />
                                </div>
                            </div>
                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="mg-t-8">Licence Issue Date</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <DatePicker className="form-control med-height" selected={formData.licenceIssueDate} onChange={(date) => handleDateChange(date, 'licenceIssueDate')} />
                                </div>
                                <div className="offset-md-1 col-md-2">
                                    <label className="mg-t-8">Licence Expiry Date</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <DatePicker className="form-control med-height" selected={formData.licenceExpiryDate} onChange={(date) => handleDateChange(date, 'licenceExpiryDate')} />
                                </div>
                            </div>
                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="mg-t-8">RC Number</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="rcNumber" className="form-control med-height" onChange={handleInputChange} value={formData.rcNumber} />
                                </div>
                                <div className="offset-md-1 col-md-2">
                                    <label className="mg-t-8">CST Number</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="cstNumber" className="form-control med-height" onChange={handleInputChange} value={formData.cstNumber} />
                                </div>
                            </div>


                            <div>
                                <h6 className="main-content-label text-primary mg-t-35 bg-gray-200 pd-8">
                                    Other Detail
                                </h6>
                            </div>
                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="mg-t-8">Money Deposite</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0 d-flex justify-content-around pd-t-8">
                                    <div>
                                        <input name="deposite" type="radio" value="Cash" className="form-check-input" onChange={handleRadioChange} checked={formData.moneyDepositeType === 'Cash'} />
                                        <label title="" className="form-check-label">By Cash</label>
                                    </div>
                                    <div>
                                        <input name="deposite" type="radio" value="Cheque" className="form-check-input" onChange={handleRadioChange} checked={formData.moneyDepositeType === 'Cheque'} />
                                        <label title="" className="form-check-label">By Cheque</label>
                                    </div>
                                    <div>
                                        <input name="deposite" type="radio" value="DD" className="form-check-input" onChange={handleRadioChange} checked={formData.moneyDepositeType === 'DD'} />
                                        <label title="" className="form-check-label">By DD</label>
                                    </div>
                                </div>
                                <div className="offset-md-1 col-md-2">
                                    <label className="mg-t-8">Amount</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="number" name="amount" min="0" className="form-control med-height" onChange={handleInputChange} value={formData.amount} />
                                </div>
                            </div>
                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="mg-t-8">Cheque/DD Number</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="chequeDdNumber" className="form-control med-height" onChange={handleInputChange} value={formData.chequeDdNumber} />
                                </div>
                                <div className="offset-md-1 col-md-2">
                                    <label className="mg-t-8">Bank Name</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="bankName" className="form-control med-height" onChange={handleInputChange} value={formData.bankName} />
                                </div>
                            </div>
                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="mg-t-8">Issue Date</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <DatePicker className="form-control med-height" selected={formData.issueDate} onChange={(date) => handleDateChange(date, 'issueDate')} />
                                </div>
                                <div className="offset-md-1 col-md-2">
                                    <label className="mg-t-8">Expiry Date</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <DatePicker className="form-control med-height" selected={formData.expiryDate} onChange={(date) => handleDateChange(date, 'expiryDate')} />
                                </div>
                            </div>
                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="mg-t-8">Remarks</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="remarks" className="form-control med-height" onChange={handleInputChange} value={formData.remarks} />
                                </div>
                            </div>
                            <div className="row row-xs mg-b-4">
                                <div className="col-md-2">
                                    <label className="mg-t-8">User Code</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="text" name="userCode" className="form-control med-height" onChange={handleInputChange} value={formData.userCode} />
                                </div>
                                <div className="offset-md-1 col-md-2">
                                    <label className="mg-t-8">Password</label>
                                </div>
                                <div className="col-md-3 mg-t-5 mg-md-t-0">
                                    <input type="password" name="password" disabled={formData.useMobileNoAsPassword} className="form-control med-height" onChange={handleInputChange} value={formData.password} />
                                    <label class="custom-switch float-end mb-0">
                                        <a href="" class="tx-14 mg-t-4 mb-0 me-2 text-dark"> <small> Use mobile number as password</small></a> <input type="checkbox" name="custom-switch-checkbox med-height" class="custom-switch-input" onChange={handleCheckboxChange} checked={formData.useMobileNoAsPassword} /> <span class="custom-switch-indicator"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="btn-list mg-t-40">
                                <button type="button" className=" btn btn-primary" onClick={handleSave}>Save</button>
                                <button type="button" className=" btn btn-light" onClick={goBack}>Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default TraderDetail;



